/**
 * DLVD Global Behaviours
 *  1. Force background videos to autoplay on mobile (iOS needs a JS nudge)
 *  2. Tilt / rise reveal on every section as it scrolls into view
 */

/* ──────────────────────────────────────────────────────────────
   1. VIDEO AUTOPLAY — runs always, even with reduced motion.
   iOS Safari ignores the autoplay attribute unless the video is
   muted AND .play() is called from script. We also retry on the
   first user interaction in case the browser blocked the first try.
   ────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  function playAll() {
    var videos = document.querySelectorAll('video[autoplay]');
    videos.forEach(function (v) {
      v.muted = true;            /* property, not just attribute — iOS needs this */
      v.setAttribute('muted', '');
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      var p = v.play();
      if (p && p.catch) { p.catch(function () { /* will retry on interaction */ }); }
    });
  }

  function retryOnce() {
    playAll();
    window.removeEventListener('touchstart', retryOnce);
    window.removeEventListener('click', retryOnce);
    window.removeEventListener('scroll', retryOnce);
  }

  function init() {
    playAll();
    /* Retry the first time the user touches / clicks / scrolls */
    window.addEventListener('touchstart', retryOnce, { passive: true, once: true });
    window.addEventListener('click', retryOnce, { once: true });
    window.addEventListener('scroll', retryOnce, { passive: true, once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ──────────────────────────────────────────────────────────────
   2. SCROLL REVEAL — tilt on desktop, smooth rise on mobile.
   Mobile deliberately avoids 3D perspective (it janks scroll on
   Safari); it uses translateY + scale + fade, which is GPU-cheap
   and clearly visible.
   ────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var isMobile  = window.innerWidth < 768;
  var DURATION  = isMobile ? 900 : 1100;
  var EASE      = 'cubic-bezier(.16,1,.3,1)';

  var HIDDEN = isMobile
    ? 'translateY(46px) scale(.97)'
    : 'perspective(1400px) rotateX(8deg) scale(.965)';
  var SHOWN = isMobile
    ? 'translateY(0) scale(1)'
    : 'perspective(1400px) rotateX(0deg) scale(1)';

  var TARGETS = [
    '.dlvd-product',
    '.dlvd-email',
    '.dlvd-footer',
    '.dlvd-cart',
    '.dlvd-page-about',
    '.dlvd-page-foundation',
    '.dlvd-page-faq'
  ].join(', ');

  if (document.documentElement.classList.contains('shopify-design-mode')) {
    function showDesignMode(root) {
      root.querySelectorAll(TARGETS).forEach(function (el) {
        el.style.opacity = '';
        el.style.transform = '';
        el.style.transition = '';
        el.style.willChange = '';
      });

      root.querySelectorAll('.dlvd-reveal, .dlvd-stagger, .dlvd-fade').forEach(function (el) {
        el.classList.add('is-visible');
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { showDesignMode(document); });
    } else {
      showDesignMode(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      showDesignMode(event.target || document);
    });
    document.addEventListener('shopify:block:select', function (event) {
      showDesignMode(event.target || document);
    });
    return;
  }

  function belowFold(el) {
    return el.getBoundingClientRect().top >= window.innerHeight * 0.98;
  }

  function prepare(el) {
    el.style.transformOrigin = '50% 0%';
    el.style.transform       = HIDDEN;
    el.style.opacity         = '0';
    el.style.transition      =
      'transform ' + DURATION + 'ms ' + EASE + ', ' +
      'opacity '   + Math.round(DURATION * 0.72) + 'ms ease';
    el.style.willChange      = 'transform, opacity';
  }

  function reveal(el) {
    el.style.transform = SHOWN;
    el.style.opacity   = '1';
    /* Clear transform once done so position:sticky (product gallery on
       desktop) works normally afterwards. */
    setTimeout(function () {
      el.style.transform  = '';
      el.style.willChange = 'auto';
    }, DURATION + 60);
  }

  function init() {
    var all = document.querySelectorAll(TARGETS);
    if (!all.length) return;

    var toAnimate = [];
    all.forEach(function (s) {
      if (belowFold(s)) {
        prepare(s);
        toAnimate.push(s);
      }
    });
    if (!toAnimate.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.04, rootMargin: '0px 0px 0px 0px' });

    toAnimate.forEach(function (s) { observer.observe(s); });
  }

  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init);
  }
})();
